import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Columns,
  Column,
  Button,
  TextInput,
  PasswordInput,
} from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import { format } from '../../../models/format'

const LoginFormWithCookie = ({
  storeInfo,
  onLogin,
  loginText,
  children,
  isLoggingIn,
  onClearCookie,
  usernameLabel,
  passwordLabel,
}) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  return (
    <Container>
      <Columns>
        <Column col12>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <div style={{ flexGrow: 1, minWidth: '25%' }}>
              <TextInput
                id="store"
                label={getText('login.store')}
                value={
                  storeInfo.storeName !== ''
                    ? storeInfo.storeName
                    : storeInfo.storeNmbr
                }
                disabled
                skipValidation
              />
            </div>
            <div style={{ flexGrow: 0, paddingTop: '3.25rem' }}>
              <Button
                size="small"
                type="link"
                onClick={onClearCookie}
                tabIndex={0}
              >
                {getText('login.changeStore')}
              </Button>
            </div>
          </div>
        </Column>
        <Column col12>
          <form onSubmit={e => onLogin(e, { username, password })}>
            <TextInput
              id="username"
              label={usernameLabel}
              required={getText('login.required.username')}
              format={format.usernameOrEmail}
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
            <PasswordInput
              id="password"
              label={passwordLabel}
              required={getText('login.required.password')}
              peek
              peekLabel={getText('login.peekPassword')}
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <div style={{ paddingTop: '.8rem' }}>
              <Button
                id="login-button"
                type="primary"
                loading={isLoggingIn}
                fullWidth
                form
              >
                {loginText}
              </Button>
            </div>

            {children}
          </form>
        </Column>
      </Columns>
    </Container>
  )
}

LoginFormWithCookie.propTypes = {
  storeInfo: PropTypes.object.isRequired,
  usernameLabel: PropTypes.string.isRequired,
  passwordLabel: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
  loginText: PropTypes.string.isRequired,
  children: PropTypes.element,
  isLoggingIn: PropTypes.bool.isRequired,
  onClearCookie: PropTypes.func.isRequired,
}

LoginFormWithCookie.defaultProps = {
  children: null,
}
export default LoginFormWithCookie
